/**
 * Row data: every work-package id in docs/PLAN.md section 10 and amendments 2.1 section 5,
 * plus the standing stewards `UI` and `TS`. Pure data (excluded from mutation testing).
 */
export const WORK_PACKAGES = [
    // Phase 0
    'P0-0',
    'P0-1',
    'P0-2',
    'P0-3',
    'P0-4',
    'P0-4b',
    'P0-5',
    'P0-6',
    'P0-7',
    'P0-8',
    'P0-9',
    'P0-10',
    'P0-11',
    'P0-11a',
    'P0-11b',
    'P0-12',
    'P0-13',
    // Phase 1
    '1.0',
    '1.1',
    '1.A',
    '1.B',
    '1.C',
    '1.D',
    '1.E',
    '1.F',
    '1.F-s',
    '1.G',
    '1.H',
    '1.I',
    '1.J',
    '1.K',
    '1.L',
    '1.M',
    '1.N',
    '1.O',
    '1.P',
    '1.Q',
    '1.R',
    '1.S',
    '1.T',
    '1.U',
    '1.V',
    '1.W',
    '1.X',
    '1.Y',
    '1.Z',
    '1.AA',
    '1.AB',
    '1.AC',
    '1.0a',
    '1.0b',
    '1.0c',
    '1.B-1',
    '1.B-2',
    '1.E-1',
    '1.E-2',
    '1.F-1',
    '1.F-2',
    '1.I-1',
    '1.I-2',
    '1.I-3',
    '1.K-1',
    '1.K-2',
    '1.L-1',
    '1.L-2',
    '1.M-1',
    '1.M-2',
    '1.N-1',
    '1.N-2',
    '1.N-3',
    '1.O-1',
    '1.O-2',
    '1.O-3',
    '1.V-1',
    '1.V-2',
    '1.Z-1',
    '1.Z-2',
    '1.AB-1',
    '1.AB-2',
    '1.AC-1',
    '1.AC-2',
    '1.GS',
    // UI-first hardening (DECISIONS 231, 234).
    '1.UF',
    // Phase 2
    '2.0a',
    '2.0b',
    '2.A',
    '2.B',
    '2.B-1',
    '2.B-2',
    '2.C',
    '2.D',
    '2.E',
    '2.F',
    '2.G',
    '2.H',
    '2.I',
    '2.I-2',
    '2.J',
    '2.K',
    '2.L',
    '2.M',
    '2.Q',
    // Phase 3
    '3.0',
    '3.A',
    '3.B',
    '3.C',
    '3.D',
    '3.E',
    '3.F',
    '3.G',
    '3.H',
    '3.I',
    '3.Q',
    // Phase 4
    '4.0',
    '4.A',
    '4.B',
    '4.C',
    '4.D',
    '4.E',
    '4.Q',
    // Phase 5
    '5.0',
    '5.A',
    '5.B',
    '5.C',
    '5.Q',
    // Standing stewards
    'UI',
    'TS',
    'CS',
    'OPS',
];
//# sourceMappingURL=rows-work-packages.js.map